export default __webpack_public_path__ + "static/media/Making-Charge.f3706189.jpg";